import React, { useState, useEffect, useRef } from 'react'
import { Query } from 'react-apollo'
import ReactTable from 'react-table'
import _ from 'lodash'
import {
  Div, H3, Loading, Button,
} from 'konsys-ui'
import config from './config'
import { theme } from '../../../styles/_variables'
import './style-css.css'
import { Wrapper, RecommendFuelModal, DeleteConfirmModal } from '../../../components/recommend-fuel-components'
import { GET_RECOMMEND_FUEL_LIST } from '../../../constants/graphql/query'
import PERMISSION from '../../../constants/permissions'

const { color } = theme

const Index = () => {
  const [modalVisible, setModalVisible] = useState(false)
  const [editData, setEditData] = useState(null)
  const [deleteModalVisible, setDeleteModalVisible] = useState(false)
  const [deleteData, setDeleteData] = useState(null)
  const [refetchFn, setRefetchFn] = useState(null)

  return (
    <Div display='flex' flexDirection='column'>
      <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center' padding='0'>
        <H3 bold color={color.primaryColor} margin='32px 0'>น้ำมันที่แนะนำทั้งหมด</H3>
        <Div display='flex' flexDirection='row' justifyContent='space-between'>
          {_.includes(window.perms, PERMISSION.CREATE_FUEL_ORDER_OVER_LIMIT) && (
            <Button onClick={() => {
              setEditData(null)
              setModalVisible(true)
            }} text='เพิ่มรายการใหม่' />
          )}
        </Div>
      </Div>
      <RecommendFuelList
        onEditClick={(rowData) => {
          setEditData(rowData)
          setModalVisible(true)
        }}
        onDeleteClick={(rowData) => {
          setDeleteData(rowData)
          setDeleteModalVisible(true)
        }}
        setRefetch={setRefetchFn}
      />
      <RecommendFuelModal
        visible={modalVisible}
        onCancel={() => {
          setModalVisible(false)
          setEditData(null)
        }}
        onSuccess={() => {
          setModalVisible(false)
          setEditData(null)
          if (refetchFn) refetchFn()
        }}
        editData={editData}
        refetch={refetchFn}
      />
      <DeleteConfirmModal
        visible={deleteModalVisible}
        onCancel={() => {
          setDeleteModalVisible(false)
          setDeleteData(null)
        }}
        onConfirm={() => {
          setDeleteModalVisible(false)
          setDeleteData(null)
          if (refetchFn) refetchFn()
        }}
        deleteData={deleteData}
        refetch={refetchFn}
      />
    </Div>
  )
}

export const RecommendFuelList = ({ onEditClick, onDeleteClick, setRefetch }) => {
  const [current, setCurrent] = useState(0)
  const [filterOptions, setFilterOptions] = useState({})
  const refetchRef = useRef(null)

  useEffect(() => {
    if (setRefetch && refetchRef.current) {
      setRefetch(() => refetchRef.current)
    }
  }, [setRefetch])

  return (
    <Wrapper overflow padding='0 0 40px 0' flex>
      <Query
        query={GET_RECOMMEND_FUEL_LIST}
        fetchPolicy='cache-and-network'
        variables={{
          limit: 5,
          offset: current * 5,
          ...filterOptions,
        }}
      >
        {
          ({
            error, loading, data, refetch,
          }) => {
            refetchRef.current = refetch

            if (error) return <p>เกิดข้อผิดพลาด</p>
            if (loading && _.isEmpty(data)) return <Loading center='true' />
            const recommendFuellist = data?.RecommendFuelList?.lists || []
            return (
              <Div margin='auto'>
                <ReactTable
                  className='table'
                  data={recommendFuellist}
                  resizable={false}
                  columns={config.getColumns(onEditClick, onDeleteClick)}
                  minRows={5}
                  manual
                  showPageSizeOptions={false}
                  sortable={false}
                  getTdProps={() => ({ disabled: false, refetch, onEditClick })}
                  getTrProps={(state, rowInfo) => {
                    if (rowInfo) {
                      return {
                        style: {
                          padding: '8px 0',
                          backgroundColor: '#ffffff',
                          borderLeft: '3px solid #D95948',
                        },
                      }
                    } return {}
                  }}
                  previousText='ก่อนหน้า'
                  nextText='ถัดไป'
                  pageText='หน้า'
                  ofText='จาก'
                  noDataText='ไม่พบข้อมูล'
                  page={current}
                  pages={Math.ceil((data?.RecommendFuelList?.totalCount || 0) / 5)}
                  onPageChange={page => setCurrent(page)}
                  onFilteredChange={async (newFiltered) => {
                    const newFilterObj = {}
                    await newFiltered.forEach((v) => {
                      switch (v.id) {
                        case 'truckBrand.name':
                          if (v.value) {
                            Object.assign(newFilterObj, {
                              truckBrandId: parseInt(v.value, 10),
                            })
                          }
                          break
                        case 'senderLocation.name':
                          if (v.value) {
                            Object.assign(newFilterObj, {
                              senderLocationId: parseInt(v.value, 10),
                            })
                          }
                          break
                        case 'receiverLocation.name':
                          if (v.value) {
                            Object.assign(newFilterObj, {
                              receiverLocationId: parseInt(v.value, 10),
                            })
                          }
                          break
                        default:
                          break
                      }
                    })
                    setFilterOptions(newFilterObj)
                    setCurrent(0)
                  }}
                />
                {
                  loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
                }
              </Div>
            )
          }
        }
      </Query>
    </Wrapper>
  )
}

export default Index
